import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {UnderwritingModel} from "./underwriting.model";

@Injectable()
export class UnderwritingService {

    private API_ROOT:string = '/pricings/underwriting';

    constructor(private http:Http) {
    }


    getOne(pricingId:number):Observable<ResponseModel<UnderwritingModel>> {
        return this.http.get(`/pricings/${pricingId}/underwriting`).map((res) => res.json());
    }

    edit(pricingId:number, fields:UnderwritingModel): Observable<ResponseModel<UnderwritingModel>>  {
        return this.http.put(`/pricings/${pricingId}/underwriting`, fields).map((res) => res.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/underwriting/underwriting.service.ts